export default __webpack_public_path__ + "static/media/icon_account.95f88440.svg";